// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getFunctions } from 'firebase/functions'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyA2DELls8csFPgf_gg8lMHjX9f6Whjc6dI',
  authDomain: 'nrf-advisor.firebaseapp.com',
  projectId: 'nrf-advisor',
  storageBucket: 'nrf-advisor.appspot.com',
  messagingSenderId: '878950934292',
  appId: '1:878950934292:web:d1759ae86e4d5aec23c401'
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
const auth = getAuth(app)
const db = getFirestore(app)
const functions = getFunctions(app)

// Connect Firestore to the emulator
// connectFirestoreEmulator(db, 'localhost', 8080)

// Connect Auth to the emulator
// connectAuthEmulator(auth, 'http://localhost:9090')

// Connect Functions to the emulator
// connectFunctionsEmulator(functions, 'localhost', 5001)

export { auth, db, functions }
